class FaqAccordionFilter extends HTMLElement {
  constructor() {
    super();
    this.pills = Array.from(this.querySelectorAll('.faq-pill'));
    this.items = Array.from(this.querySelectorAll('.faq-accordion__item'));

    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.setActive(pill));
    });

    this.updateLastVisible();
  }

  setActive(pill) {
    this.pills.forEach((p) => p.classList.toggle('is-active', p === pill));

    const category = pill.dataset.faqCategory;
    this.items.forEach((item) => {
      item.hidden = item.dataset.faqCategory !== category;
    });

    this.updateLastVisible();
  }

  updateLastVisible() {
    const visibleItems = this.items.filter((item) => !item.hidden);
    this.items.forEach((item) => {
      item.classList.toggle('is-last-visible', item === visibleItems[visibleItems.length - 1]);
    });
  }
}

customElements.define('faq-accordion-filter', FaqAccordionFilter);
